import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["panel", "navStep"]

  connect() {
    this.currentStep = 1
    // Initial sync: hidden panels should not have required fields enforced
    this.syncRequiredAttributes()
  }

  next() {
    // Validate current panel before advancing
    if (!this.validateCurrentPanel()) return
    this.goTo(this.currentStep + 1)
  }

  prev() {
    this.goTo(this.currentStep - 1)
  }

  goToStep(event) {
    const step = parseInt(event.currentTarget.dataset.step)
    // Going backwards is always allowed; forwards requires validation
    if (step > this.currentStep && !this.validateCurrentPanel()) return
    this.goTo(step)
  }

  goTo(step) {
    const totalSteps = this.panelTargets.length
    if (step < 1 || step > totalSteps) return

    this.currentStep = step

    this.panelTargets.forEach(panel => {
      const panelStep = parseInt(panel.dataset.step)
      panel.classList.toggle("d-none", panelStep !== step)
    })

    this.navStepTargets.forEach((nav, index) => {
      const navStep = index + 1
      nav.classList.toggle("active", navStep === step)
      nav.classList.toggle("completed", navStep < step)
    })

    // Sync required attributes so hidden fields don't block form submission
    this.syncRequiredAttributes()
  }

  validateCurrentPanel() {
    const currentPanel = this.panelTargets.find(p => parseInt(p.dataset.step) === this.currentStep)
    if (!currentPanel) return true

    const fields = currentPanel.querySelectorAll("input[required], textarea[required], select[required]")
    for (const field of fields) {
      if (!field.checkValidity()) {
        field.reportValidity()
        return false
      }
    }
    return true
  }

  // Save original required state and toggle `required` based on panel visibility.
  // Browser HTML5 validation will only enforce required on currently visible fields.
  syncRequiredAttributes() {
    this.panelTargets.forEach(panel => {
      const isHidden = panel.classList.contains("d-none")
      const fields = panel.querySelectorAll("input, textarea, select")
      fields.forEach(field => {
        if (field.dataset.originallyRequired === undefined) {
          field.dataset.originallyRequired = field.required ? "true" : "false"
        }
        const wasRequired = field.dataset.originallyRequired === "true"
        field.required = !isHidden && wasRequired
      })
    })
  }
}
